// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui'
import BaiduMap from  'vue-baidu-map'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import VueI18n from 'vue-i18n'

import 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'swiper/dist/css/swiper.css'
import './assets/css/common.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import axios from 'axios'
import store from './store/store.js'
import VueLazyload from 'vue-lazyload'
// import  'assets/styles/index.less'
Vue.use(ElementUI)
Vue.use(vueSwiper)
Vue.use(VueLazyload)
Vue.use(BaiduMap,{
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '3NYo1ipWyAPpWNIxmgobB5IYTESgCmb2'
})
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: Object.assign(require('../static/language/chinese.json'), zhLocale),
    en: Object.assign(require('../static/language/english.json'), enLocale)
  }
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1,
//   // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
//   listenEvents: [ 'scroll' ]
// });

Vue.config.productionTip = false
//  axios.get('./static/project.config.json').then((result) => {
//      Vue.prototype.baseConfig = result.data
//  })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js